import React from 'react';
import { ArrowLeft, ArrowRight } from 'lucide-react';

const navClass = 'flex items-center gap-2 text-[#888] hover:text-white transition-colors text-sm';

export const PhotoNav = ({ prevPhoto, nextPhoto, onNavigate }) => (
  <div className="flex justify-between mt-4" data-testid="photo-nav">
    {prevPhoto ? (
      <button onClick={() => onNavigate(prevPhoto.id)} className={navClass} data-testid="photo-prev-btn">
        <ArrowLeft className="w-4 h-4" />
        Previous
      </button>
    ) : <div />}
    {nextPhoto && (
      <button onClick={() => onNavigate(nextPhoto.id)} className={navClass} data-testid="photo-next-btn">
        Next
        <ArrowRight className="w-4 h-4" />
      </button>
    )}
  </div>
);
